export default __webpack_public_path__ + "static/media/chain.ce163c35.png";